import { bankOperationDetailSchema } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';
import type { BankOperationDetail } from '../../model/bank-operation.js';
import type { BankOperationDetailDto } from '../dto/bank-operation.dto.js';
import { toBankOperationDetail } from '../mappers/bank-operation.mapper.js';

const fetchBankOperation = async (
  id: string,
  signal: AbortSignal,
): Promise<BankOperationDetailDto> =>
  bankOperationDetailSchema.parse(
    await apiRequest<unknown>(`/bank/transactions/${id}`, { signal }),
  );

export const getBankOperation = async (
  id: string,
  signal: AbortSignal,
): Promise<BankOperationDetail> => toBankOperationDetail(await fetchBankOperation(id, signal));
